import { ValidationErrors, ValidatorFn } from "@angular/forms";
import ValidatorPatterns = stages.context.ValidatorPatterns;

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class StagesValidators {
	private static validateEmails(value: string, pattern: string | null, asList: boolean): ValidationErrors | null {
		if (!pattern || !value) {
			return null;
		}
		const regex = new RegExp(pattern);
		const emails = asList
			? value
					.split(";")
					.map((e) => e.trim())
					.filter((e) => !!e)
			: [value.trim()];

		const invalid = emails.filter((email) => !regex.test(email.toLowerCase()));
		return invalid.length ? { invalid: { invalid } } : null;
	}

	static stagesEmail(validatorPatterns: ValidatorPatterns): ValidatorFn {
		return (control) => this.validateEmails(control.value as string, validatorPatterns.emailPattern, false);
	}

	static stagesEmailList(validatorPatterns: ValidatorPatterns): ValidatorFn {
		return (control) => this.validateEmails(control.value as string, validatorPatterns.emailPattern, true);
	}
}
